import React from 'react';
import Collapse from 'rc-collapse';
import { Row, Col } from 'reactstrap';
import 'rc-collapse/assets/index.css';
import styled from 'styled-components';
import Message from 'rc-message';
import { IconNames } from '@blueprintjs/icons';
import * as _ from 'lodash';
import {
  Checkbox,
  Spinner,
  Intent,
  Icon,
  InputGroup,
  ControlGroup,
  Divider,
  Dialog,
  Button,
} from '@blueprintjs/core';
import { ListGroupItem } from 'reactstrap';
import { createForm } from 'rc-form';

import RoleSelect from 'components/elements/select-role';
import { permissionRole, moduleName, permissionRoleName } from 'constants/role';
import { create, getOne, updateOne } from 'api/roleApi';
import Clearfix from 'components/elements/clearfix';
import IconRequired from 'components/elements/required-icon';
import { COLOR } from 'config';

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;

const Panel = Collapse.Panel;

const rolePaths = _.keys(flatObject(permissionRole()));

function flatObject(input) {
  function flat(res, key, val, pre = '') {
    const prefix = [pre, key].filter((v) => v).join('.');
    return typeof val === 'object'
      ? Object.keys(val).reduce(
          (prev, curr) => flat(prev, curr, val[curr], prefix),
          res
        )
      : Object.assign(res, { [prefix]: val });
  }

  return Object.keys(input).reduce(
    (prev, curr) => flat(prev, curr, input[curr]),
    {}
  );
}

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;
const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

class UserPanel extends React.Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
  }

  updateRole = (path, value) => {
    const keys = _.keys(this.state.targetedRole);
    const targetedRole = this.state.targetedRole;
    const data = permissionRole();
    _.forEach(keys, (str) => {
      if (!data[str]) {
        delete targetedRole[str];
      }
    });

    this.setState({
      targetedRole: _.update(targetedRole, path, () => value),
    });
  };

  state = {
    targetedRole: null,
    _idObject: '',
    Name: '',
    isLoading: false,
    isReload: false,
    isOpenNumberPermit: false,
    isEdit: false,
    isUpdate: false,
  };

  submitCreate = async () => {
    this.props.form.validateFields(async (error, value) => {
      if (error) return;
      this.setState({
        isLoading: true,
        isReload: true,
      });
      const res = await create({ Name: value.Name });
      if (res.success) {
        Message.success({ content: 'Thành Công' });
        this.setState({ isOpenNumberPermit: false });
      } else {
        Message.error({ content: 'Đã có lỗi xảy ra!!!' });
      }
      this.setState({
        isLoading: false,
        isReload: false,
      });
    });
  };

  submitUpdate = async () => {
    this.props.form.validateFields(async (error, value) => {
      if (error) return;
      this.setState({
        isLoading: true,
        isUpdate: true,
      });
      const res = await updateOne(this.state._idObject, {
        ...value,
        permissionRole: this.state.targetedRole,
      });
      if (res.success) {
        Message.success({ content: 'Thành Công' });
      } else {
        Message.error({ content: 'Đã có lỗi xảy ra!!!' });
      }
      this.setState({
        isUpdate: false,
        isLoading: false,
        Name: value.Name,
      });
    });
  };

  async loadRole(_id) {
    this.setState({ isLoading: true, targetedRole: null });
    const res = await getOne(_id);
    let targetedRole = null;
    let Name = '';
    let _idObject = '';
    if (res.success) {
      Name = res.data.Name;
      targetedRole = res.data.permissionRole || {};
      _idObject = res.data._id;
    }
    this.setState({ isLoading: false, targetedRole, Name, _idObject });
  }

  getPermissionRole = () => {
    const permissionRoles = _.values(permissionRole());
    const keys = _.keys(permissionRole());

    const module = _.map(keys, (key, inx) => {
      return permissionRoles[inx] && permissionRoles[inx].isVisible
        ? key
        : null;
    });

    return _.compact(module);
  };

  renderDialogNumberPermit = () => {
    const { getFieldProps, getFieldError } = this.props.form;
    return (
      <Dialog
        style={{ background: 'white' }}
        icon='info-sign'
        onClose={() => {
          this.setState({
            isOpenNumberPermit: false,
          });
        }}
        title={`Tạo vai trò`}
        isOpen={this.state.isOpenNumberPermit}
      >
        <div style={{ padding: 8 }}>
          <Clearfix height={8} />
          <Row>
            <Col xs={3}>
              <LabelContainer>Tên vai trò</LabelContainer>
            </Col>
            <Col xs={8}>
              <InputGroup
                placeholder='Tên vai trò'
                fill
                {...getFieldProps('Name', {
                  rules: [
                    {
                      whitespace: true,
                      required: true,
                      message: 'Vui lòng nhập tên vai trò',
                    },
                    {
                      whitespace: true,
                      min: 3,
                      max: 64,
                      message: 'Tên vai trò có độ dài từ 3 -> 64 kí tự',
                    },
                  ],
                })}
              />
              <ErrorContainer>
                {(getFieldError('Name') || []).join(', ')}
              </ErrorContainer>
            </Col>
          </Row>
          <Clearfix height={8} />
          <Row>
            <Col>
              <Button
                onClick={this.submitCreate}
                icon='saved'
                className='bp3-intent-success float-right'
                style={{
                  backgroundColor: COLOR.SUCCESS,
                  color: COLOR.TEXT_COLOR,
                }}
              >
                Lưu
              </Button>
            </Col>
          </Row>
        </div>
      </Dialog>
    );
  };

  render() {
    const { getFieldProps, getFieldError } = this.props.form;
    const modules = this.getPermissionRole();

    return (
      <div style={{ width: '100%' }}>
        {this.renderDialogNumberPermit()}
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <HeaderContainer>
              {this.state.isEdit && (
                <div>
                  <Icon
                    onClick={() => {
                      this.selectRef.current.resetValue();
                      this.setState({
                        targetedRole: null,
                        isEdit: false,
                      });
                    }}
                    style={{
                      cursor: 'pointer',
                      color: COLOR.SUCCESS,
                      marginRight: '6px',
                    }}
                    icon={IconNames.CIRCLE_ARROW_LEFT}
                    iconSize={Icon.SIZE_LARGE}
                    intent={Intent.SUCCESS}
                  />
                  {/* <Clearfix width={8} /> */}
                  <Icon
                    icon={IconNames.SAVED}
                    iconSize={Icon.SIZE_LARGE}
                    intent={Intent.PRIMARY}
                    onClick={this.submitUpdate}
                    style={{ color: COLOR.SUCCESS }}
                  />
                </div>
              )}
            </HeaderContainer>

            <Clearfix width={8} />
          </Col>
        </Row>

        <Row>
          <Col xs={2}>
            <LabelContainer>
              Vai trò
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={8}>
            {this.state.isReload && (
              <div style={{ height: 30 }} className='bp3-skeleton' />
            )}
            {!this.state.isReload && (
              <RoleSelect
                ref={this.selectRef}
                defaultValue={{
                  value: this.state._idObject,
                  label: this.state.Name,
                }}
                hideLabel
                className='bp3-small'
                onChange={(selected) => {
                  this.loadRole(selected.value);
                  this.setState({ isEdit: true });
                }}
                isUpdate={this.state.isUpdate}
              />
            )}
          </Col>
          <div
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            xs={1}
          >
            {!this.state.isEdit && (
              <Icon
                onClick={() => {
                  this.setState({
                    isOpenNumberPermit: true,
                  });
                }}
                icon={IconNames.ADD}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.SUCCESS}
                style={{ color: COLOR.SUCCESS }}
              />
            )}
          </div>
        </Row>
        <Clearfix height={15} />

        {this.state.isLoading && <Spinner intent={Intent.PRIMARY} size={200} />}

        {this.state.targetedRole && (
          <ControlGroup fill={true} vertical={true}>
            <Divider />
            <Clearfix height={15} />
            <Row>
              <Col xs={2}>
                <LabelContainer>
                  Tên vai trò
                  <IconRequired />
                </LabelContainer>
              </Col>
              <Col xs={8}>
                <InputGroup
                  placeholder='Tên vai trò'
                  fill
                  {...getFieldProps('Name', {
                    initialValue: this.state.Name,
                    rules: [
                      {
                        whitespace: true,
                        required: true,
                        message: 'Vui lòng nhập tên vai trò',
                      },
                      {
                        whitespace: true,
                        min: 3,
                        max: 64,
                        message: 'Tên vai trò có độ dài từ 3 -> 64 kí tự',
                      },
                    ],
                  })}
                />
                <ErrorContainer>
                  {(getFieldError('Name') || []).join(', ')}
                </ErrorContainer>
              </Col>
            </Row>
            <Clearfix height={8} />
            <Row>
              <Col xs={2}></Col>
              <Col xs={8}>
                <Collapse defaultActiveKey={modules}>
                  {modules.map((mol) => {
                    const molduleRoles = rolePaths.filter((path) =>
                      path.includes(mol + '.')
                    );
                    // console.log(moduleName, "--molduleRoles--")
                    return (
                      <Panel
                        key={mol}
                        header={moduleName[mol]}
                        headerClass='rc-collampse-header-custom'
                      >
                        {molduleRoles.map((molRule) => {
                          if (molRule.includes('isVisible')) {
                            return null;
                          }
                          return (
                            <ListGroupItem key={molRule}>
                              <Col xs={8}>
                                <Checkbox
                                  defaultChecked={_.result(
                                    this.state.targetedRole,
                                    molRule,
                                    false
                                  )}
                                  className='bp3-align-right'
                                  label={permissionRoleName[molRule]}
                                  onChange={(e) => {
                                    // console.log(molRule, e.target.checked);
                                    this.updateRole(molRule, e.target.checked);
                                  }}
                                />
                              </Col>
                            </ListGroupItem>
                          );
                        })}
                      </Panel>
                    );
                  })}
                </Collapse>
              </Col>
            </Row>
          </ControlGroup>
        )}

        <Clearfix height={8} />
      </div>
    );
  }
}

export default createForm()(UserPanel);



// WEBPACK FOOTER //
// ./src/containers/AdminContainer/RolePanel/index.js